import React from 'react';

import Close from '@mui/icons-material/Close';
import {
  Divider,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';

import { ShortStudent } from '../../services/students/types';
import Link from '../Link';
import ProfileIcon from '../ProfileIcon';
import StudentStateChip from '../StudentStateChip';

interface StudentCardProps {
  student: ShortStudent,
  onClose?: () => void,
  showState?: boolean,
  linkable?: boolean,
}

const StudentCard = ({
  student,
  onClose,
  showState = true,
  linkable = true,
}: StudentCardProps) => (
  <Stack
    direction="row"
    justifyContent="space-between"
    alignItems="center"
  >
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
    >
      <ProfileIcon
        firstName={student.firstName}
        lastName={student.lastName}
        color={student.profileIcon?.color}
        imageUrl={student.profileIcon?.image}
        size={36}
      />
      <Stack direction="column">
        {linkable ? (
          <Link href={`/admin/student/${student.studentId}`} fontWeight="bold">
            {student.name}{student.school && ` (${student.school})`}
          </Link>
        ) : (
          <Typography fontWeight="bold">
            {student.name}{student.school && ` (${student.school})`}
          </Typography>
        )}
        <Stack
          direction="row"
          spacing={1}
          divider={
            <Divider orientation="vertical" flexItem />
          }
          alignItems="center"
        >
          <Typography variant="body2">
            {student.email}
          </Typography>
          <Typography variant="body2">
            {student.phoneNumber}
          </Typography>
        </Stack>
      </Stack>
      {showState && <StudentStateChip state={student.state} />}
    </Stack>
    {onClose && (
      <IconButton onClick={onClose}>
        <Close />
      </IconButton>
    )}
  </Stack>
);
export default StudentCard;
